import writeExcelFile from "write-excel-file/browser";

//Utilidades para exportar a Excel (.xlsx) con write-excel-file.
//Todas las exportaciones del sistema pasan por aca.

const INVALID_SHEET_CHARS = /[:\\/?*[\]]/g;

//Normaliza cualquier valor a una celda valida de write-excel-file.
//Los valores vacios (null, undefined, "") quedan como celda vacia.
export const toCell = (value, style = {}) => {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number") {
    return Number.isFinite(value)
      ? { value, type: Number, ...style }
      : { value: String(value), type: String, ...style };
  }
  if (typeof value === "boolean") return { value, type: Boolean, ...style };
  if (value instanceof Date) {
    return isNaN(value)
      ? null
      : { value, type: Date, format: "dd/mm/yyyy hh:mm", ...style };
  }
  return { value: String(value), type: String, ...style };
};

//Lista de objetos -> filas (la primera fila es la cabecera con las claves)
export const objectsToSheetData = (objects) => {
  const headers = [];
  const seen = new Set();
  objects.forEach((obj) => {
    Object.keys(obj || {}).forEach((key) => {
      if (!seen.has(key)) {
        seen.add(key);
        headers.push(key);
      }
    });
  });
  return [
    headers.map((h) => toCell(h)),
    ...objects.map((obj) => headers.map((h) => toCell(obj?.[h]))),
  ];
};

//Definicion de columnas [{header, key, width}] + filas (objetos) -> hoja
export const columnsToSheet = (
  columns,
  rows,
  { headerStyle = {}, cellStyle = {} } = {}
) => ({
  data: [
    columns.map((c) => toCell(c.header, headerStyle)),
    ...rows.map((row) => columns.map((c) => toCell(row[c.key], cellStyle))),
  ],
  columns: columns.map((c) => ({ width: c.width })),
});

//Genera y descarga el archivo. sheets: [{ data, sheet, columns }]
export const saveXlsx = (sheets, fileName) => {
  const used = new Set();
  const namedSheets = sheets.map(({ sheet, ...rest }, i) => {
    const base =
      String(sheet ?? "")
        .replace(INVALID_SHEET_CHARS, "-")
        .trim()
        .slice(0, 31) || `Hoja ${i + 1}`;
    let name = base;
    let n = 2;
    while (used.has(name.toLowerCase())) {
      const suffix = ` (${n++})`;
      name = base.slice(0, 31 - suffix.length) + suffix;
    }
    used.add(name.toLowerCase());
    return { ...rest, sheet: name };
  });
  const name = String(fileName);
  const fullName = name.toLowerCase().endsWith(".xlsx") ? name : `${name}.xlsx`;
  return writeExcelFile(namedSheets).toFile(fullName);
};
